// extracted by mini-css-extract-plugin
var _1 = "nBw1O__icon";
var _2 = "nBw1O__reverseRollButton";
export { _1 as "icon", _2 as "reverseRollButton" }
